import React from "react";

/** 26px SVG completion ring matching PRD ringHTML */
const CompletionRing: React.FC<{ pct: number; color: string }> = ({
  pct,
  color,
}) => {
  const clamped = Math.max(0, Math.min(100, Math.round(pct || 0)));
  const r = 10;
  const c = 2 * Math.PI * r;
  const off = c * (1 - clamped / 100);
  return (
    <span className="ring" aria-hidden>
      <svg width="26" height="26" viewBox="0 0 26 26">
        <circle
          cx="13"
          cy="13"
          r={r}
          fill="none"
          stroke="var(--line-2)"
          strokeWidth="3"
        />
        <circle
          cx="13"
          cy="13"
          r={r}
          fill="none"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray={c.toFixed(1)}
          strokeDashoffset={off.toFixed(1)}
          transform="rotate(-90 13 13)"
        />
        <text
          x="13"
          y="13"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize="7.5"
          fontWeight="700"
          fill="var(--muted)"
        >
          {clamped}
        </text>
      </svg>
    </span>
  );
};

export default CompletionRing;
